import {
    ControlCenterOpenSource,
    Enviroments,
    IControlCenterBaseSpecificParams,
    IDivHostedAppInitParameters,
} from '@sparkware/uc-sdk-core';
import {IServiceFactoryExtended} from '../../../../service-factory-extended.interface';

export function getInitAppParamsForControlCenter(initParams: IDivHostedAppInitParameters, services: IServiceFactoryExtended): IDivHostedAppInitParameters {
    initParams.applicationContext.launchInfo.appSpecificParameters = getAppSpecificParamsForControlCenter(initParams.applicationContext.launchInfo.appSpecificParameters, services);

    // The env property should be sent for all applications and setting it should be in CasinofiedApplicationBase (casinofied-application-base.ts) nethod _getAppInitCommonParams
    // But because we did not sent it to other applications and we don't have the exact values to send, we only send it to control center
    initParams["env"] = services.configuration.startupConfiguration.sdk.config.ExtraProperties.env as Enviroments;

    return initParams;
}

export function getAppSpecificParamsForControlCenter<T extends IControlCenterBaseSpecificParams>(appSpecificParameters: T, services: IServiceFactoryExtended) {
    let source = appSpecificParameters?.source ?? ControlCenterOpenSource.Lobby;

    return {
        clientPlatform: parseInt(services.sdk.getSkin().getClientPlatform()),
        ...appSpecificParameters,
        source
    };

}
